module.exports = __webpack_public_path__ + "img/tareas.25500949.svg";